import { OTPField as BaseOTPField } from '@base-ui/react/otp-field';
import type { ComponentProps } from 'react';
import { cx } from '../lib/styled.tsx';

export interface OTPFieldProps extends ComponentProps<typeof BaseOTPField.Root> {
  className?: string;
}

/**
 * The boxes a one-time code is typed into.
 *
 * The slots are generated from `length` — they carry no content of their own,
 * and writing them out by hand only invites a mismatch between the number of
 * boxes and the length the field actually validates. Each gets the positional
 * label screen readers need to announce which character is being edited.
 */
export function OTPField({ length, className, ...props }: OTPFieldProps) {
  return (
    <BaseOTPField.Root className={cx('flex gap-2', className)} length={length} {...props}>
      {Array.from({ length }, (_, index) => (
        <BaseOTPField.Input
          // biome-ignore lint/suspicious/noArrayIndexKey: slots are positional and never reorder
          key={index}
          aria-label={index === 0 ? undefined : `Character ${index + 1} of ${length}`}
          className={cx(
            'size-11 rounded-control border border-border-subtle bg-surface',
            'text-center text-lg tabular-nums text-ink',
            'focus:border-brand-400 focus:outline-none focus:ring-2 focus:ring-brand-400/35',
            'data-invalid:border-danger',
            'data-disabled:cursor-not-allowed data-disabled:bg-surface-muted data-disabled:text-ink-faint',
          )}
        />
      ))}
    </BaseOTPField.Root>
  );
}
